import * as React from 'react';
import { useContext } from 'react';
import { Button } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { MobilePhoneFetcher } from './MobilePhoneFetcher';
import { trackCallButtonClick } from './tracking';
import { TPlaceType } from '../../types/promoOffersSelection/callButton';
import { getPhoneLink } from '../../utils/phone';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';

interface IMobileCallButtonProps {
  placeType: TPlaceType;
}

export const MobileCallButton = ({ placeType }: IMobileCallButtonProps) => {
  const { siteBlockId, builder, offerId, gaLabel } = useContext(PromoOfferCardContext);

  const linkPhone = React.useMemo(() => {
    if (!builder || builder.phones.length === 0) {
      return null;
    }

    return getPhoneLink(builder.phones[0]);
  }, [builder]);

  const [needFetchPhone, setNeedFetchPhone] = React.useState(false);

  const onCallClick = React.useCallback(() => {
    trackCallButtonClick({
      action: 'Open_detail_promo',
      customUrl: gaLabel,
      id: offerId,
    });
    if (siteBlockId) {
      setNeedFetchPhone(true);

      return;
    }

    window.open(linkPhone as string, '_self');
  }, [gaLabel, linkPhone, offerId, siteBlockId]);

  /* istanbul ignore next */
  if (!linkPhone) {
    return null;
  }

  return (
    <>
      <Button
        onClick={onCallClick}
        size="L"
        theme="fill_primary"
        fullWidth
        beforeIcon={<IconCommunicationPhone16 color="current_color" />}
      >
        Позвонить застройщику
      </Button>
      {needFetchPhone && <MobilePhoneFetcher placeType={placeType} />}
    </>
  );
};
